import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _jsxFileName = "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DLS-WEB7-JOB1/src/components/BulletList/BulletList.js",
  _templateObject,
  _this = this;
import React from 'react';
import styled, { css } from 'styled-components';
import Text from '../Text';
import { withTheme } from '../../core/ThemeProvider';
import { withStyledAttrs } from '../../helpers/styled';
var Wrapper = withStyledAttrs(Text, {
  type: 'body',
  tag: 'span'
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var TextWrapper = withTheme(styled.div.withConfig({
  displayName: "BulletList__TextWrapper",
  componentId: "sc-3fnm0u-0"
})(["padding:0 0 8px 26px;", ""], function (props) {
  return props.size === 'small' && 'padding-bottom: 0px;';
}));
var DotWrapper = withTheme(styled.div.withConfig({
  displayName: "BulletList__DotWrapper",
  componentId: "sc-3fnm0u-1"
})(function (_ref) {
  var coreTheme = _ref.coreTheme;
  return css(["position:absolute;margin:0 ", "px 0 ", "px;display:flex;justify-content:center;align-items:center;&::after{content:'.';visibility:hidden;width:0;}"], coreTheme.space_3, coreTheme.space_2);
}));
var Dot = withTheme(styled.span.withConfig({
  displayName: "BulletList__Dot",
  componentId: "sc-3fnm0u-2"
})(["line-height:inherit;height:6px;width:6px;background-color:", ";border-radius:50%;display:inline-block;margin-bottom:2px;"], function (p) {
  return p.coreTheme.cl_ter_base;
}));
var BulletList = function BulletList(_ref2) {
  var children = _ref2.children,
    size = _ref2.size;
  return /*#__PURE__*/React.createElement(Wrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 3
    }
  }, /*#__PURE__*/React.createElement(DotWrapper, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(Dot, {
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 7
    }
  })), /*#__PURE__*/React.createElement(TextWrapper, {
    size: size,
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 5
    }
  }, children));
};
BulletList.defaultProps = {
  size: 'default'
};
export default BulletList;